import React, { useState } from "react";
import { Input, message, Modal } from "antd";
import moment from "moment";
import { DateFormat } from "../../../../enums/dateTimeFormat";
import {
  FileUploader,
  UploadedFileItem,
} from "../../../../reusable-components/FileUploader";
import styles from "./RejectModal.module.scss";
import { FileTypes } from "../../../../enums/FileUploadEnums";
import { Storage } from "aws-amplify";

const { TextArea } = Input;

interface RejectModalProps {
  visible: boolean;
  record?: Object;
  onCancel: () => void;
  onConfirm: (payload) => void;
}

export const RejectModal = ({
  visible,
  record,
  onCancel,
  onConfirm,
}: RejectModalProps) => {
  const [notes, setNotes] = useState("");
  const [fileList, setFileList] = useState<UploadedFileItem[]>([]);

  const cleanupUploadedFiles = async () => {
    const uploaded = fileList.filter((f) => f.s3Key);
    try {
      await Promise.all(uploaded.map((f) => Storage.remove(f.s3Key)));
    } catch (error) {
      console.error("Failed to remove files");
    }
  };

  const handleCancel = async () => {
    await cleanupUploadedFiles();
    setNotes("");
    setFileList([]);
    onCancel();
  };

  const handleConfirm = async () => {
    if (!fileList.length) {
      message.error("Atleast one file is required to reject the revised price");
      return;
    }
    const documents = fileList
      .filter((file) => file.url)
      .map((file) => ({
        name: file.name,
        url: file.url,
      }));

    const payload = {
      date: moment().format(DateFormat.MM_DD_YYYY_SLASHED),
      notes: notes?.trim() ?? "",
      documents,
    };
    try {
      await onConfirm(payload);
      setNotes("");
      setFileList([]);
    } catch (error) {
      console.error(error as Error);
    }
    return;
  };

  return (
    <Modal
      okText={"Confirm"}
      onOk={handleConfirm}
      visible={visible}
      onCancel={handleCancel}
      title={"Keep Old Pricing"}
      width={746}
      maskClosable={false}
      destroyOnClose
    >
      <div className={styles.fieldTitleDocuments}>
        Please upload any evidence of old price guarantee
      </div>
      <FileUploader
        fileList={fileList}
        setFileList={setFileList}
        maxCount={5}
        maxSizeMB={5}
        allowedFileTypes={[
          FileTypes.PDF,
          FileTypes.DOC,
          FileTypes.DOCX,
          FileTypes.XLS,
          FileTypes.XLSX,
          FileTypes.CSV,
          FileTypes.JPEG,
          FileTypes.JPG,
          FileTypes.PNG,
        ]}
      />
      <div className={styles.fieldTitleNotes}>Notes</div>
      <TextArea
        placeholder="Enter notes"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        rows={2}
      />
    </Modal>
  );
};
